module.exports = __webpack_public_path__ + "59939c4b1077f359a254002a9661456b.svg";